<template>
    <div v-if="filters">
        <div class="trademark-buttons-wrapper">
            <div class="white-button trademark-button" :class="{ active: !isCategoryFilterActive }">
                <button class="text-uppercase-based-on-eshop shop-button" @click="clearCategoryFilters">
                    {{ __('frontend_js.category.all-categories') }}
                    <span v-if="canViewCount"> ({{ coloredProductsWithCategory.length }}) </span>
                </button>
            </div>
            <template v-for="category in categoryTree">
                <product-category-filter-main-item :key="category.id" :category="category" :can-view-count="canViewCount" />
            </template>
        </div>
        <div v-for="category in categoryTree" :key="category.id">
            <product-category-filter-sub :parent="category" :can-view-count="canViewCount" />
        </div>
    </div>
</template>

<script>
import collect from 'collect.js';

export default {
    props: {
        categoryTree: { required: true },
        //   canViewCount: { required: false },
        filterData: { required: true },
        coloredProductsForFilter: { required: true },
    },

    data() {
        return {
            canViewCount: true,
        };
    },

    computed: {
        filters() {
            return this.$store.getters['product-filters/filters'];
        },
        coloredProducts() {
            return this.$store.getters['product-filters/coloredProducts'];
        },
        isCategoryFilterActive() {
            return this.filters?.categories?.length > 0;
        },
        coloredProductsWithCategory() {
            if (!this.coloredProducts) return [];
            return this.coloredProducts.filter(coloredProduct => {
                for (const key in this.filters) {
                    if (this.filters[key].length == 0) continue;
                    if (key == 'categories') continue;
                    if (collect(this.filters[key]).intersect(coloredProduct[key]).count() == 0) return false;
                }

                return true;
            });
        },
    },

    created() {
        this.$store.commit('product-filters/SET_CATEGORY_TREE', this.categoryTree);
        this.$store.commit('product-filters/SET_COLORED_PRODUCTS', this.coloredProductsForFilter);
        this.$store.commit('product-filters/SET_FILTER_DATA', this.filterData.data);
        this.$store.commit('product-filters/SET_FILTERS');
    },

    methods: {
        clearCategoryFilters() {
            this.$store.commit('product-list/SET_LOADING', true);

            setTimeout(() => {
                this.$store.commit('product-filters/SET_FILTER', {
                    key: 'categories',
                    value: [],
                });

                setTimeout(() => {
                    this.$root.$emit('filterChanged');
                }, 10);
            }, 10);
        },
    },
};
</script>

<style lang="scss" scoped></style>
